/** An expected, non-bug failure that `log.error` skips reporting to Sentry. */
export class ExpectedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ExpectedError";
  }
}
